const api = {
	listMerchantBills: '/mallSettlement/listMerchantBills', // 查询店铺商户账单列表
	listMerchantBillDates: '/mallSettlement/listMerchantBillDates', // 查询d店铺结算周期列表
	downloadBillDetail: '/mallSettlement/downloadBillDetail', // 下载结算明细
	getMallBillDetail: '/mallSettlement/getBillDetail'
};

const routes = {
	'/shop-bill': '对账单',
	'/shop-bill/detail': '对账明细'
};

export { api, routes };
